import { useState } from "react";
import { CustomerRead } from "../../../../types";

export function useManageCustomer() {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<CustomerRead | null>(
    null,
  );

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedCustomer(null);
  };

  const handleRowClick = (rowData: { data: CustomerRead }) => {
    setSelectedCustomer(rowData.data);
    setIsDetailsModalOpen(true);
  };

  return {
    handleRowClick,
    selectedCustomer,
    isDetailsModalOpen,
    handleCloseDetailsModal,
  };
}
